/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const Pagination = styled.div({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  marginTop: token('space.300'),
  marginBottom: token('space.300'),
});

export const PaginationWrapper = styled.div({
  marginBottom: token('space.200'),
});
